export default "__VITE_ASSET__JWndW_Oo__"